import qs from 'qs';

const { API_ENDPOINT } = process.env;

const getCookie = name => {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2)
		return parts
			.pop()
			.split(';')
			.shift();
	return null;
};

// 取得 XSRF-TOKEN 並加到 headers（僅用於 POST、PUT、DELETE method）
const appendXsrfToken = (headers, method = 'GET') => {
	const needsCsrf = ['POST', 'PUT', 'DELETE', 'PATCH'].includes(method.toUpperCase());
	if (!needsCsrf) return;

	const xsrfToken = getCookie('XSRF-TOKEN');
	if (xsrfToken) {
		headers.set('X-XSRF-TOKEN', decodeURIComponent(xsrfToken));
	}
};

export const generateUrl = (url, params, version = 'v1') => {
	const paramsString = qs.stringify(params, { arrayFormat: 'brackets', encode: encodeURI });

	const URL =
		paramsString !== ''
			? `${API_ENDPOINT}/backstage/api/${version}/${url}?${paramsString}`
			: `${API_ENDPOINT}/backstage/api/${version}/${url}`;

	return URL;
};

export const wrapFetch = async (url, options = { headers: {} }, params = {}, version = 'v1') => {
	const URL = generateUrl(url, params, version);

	const headers = new Headers({
		'Content-Type': 'application/json',
		Accept: 'application/json',
		...options.headers,
	});

	appendXsrfToken(headers, options.method);

	const result = await fetch(URL, { ...options, headers, credentials: 'include' });

	return result.json();
};

export const wrapAuthFetch = async (
	url,
	options = { headers: {} },
	params = {},
	version = 'v1',
) => {
	return wrapFetch(url, options, params, version);
};

export const wrapFetchFormData = async (url, options, params = {}) => {
	const URL = generateUrl(url, params);

	const headers = new Headers(options.headers || {});
	appendXsrfToken(headers, options.method);

	const result = await fetch(URL, { ...options, headers, credentials: 'include' });

	return result.json();
};

export const wrapAuthFetchFormData = async (url, options, params = {}) => {
	return wrapFetchFormData(url, options, params);
};

export const apiUrl = (url, params) => {
	const paramsString = qs.stringify(params, { arrayFormat: 'brackets' });

	const URL =
		paramsString !== ''
			? `${API_ENDPOINT}/backstage/api/${url}?${paramsString}`
			: `${API_ENDPOINT}/backstage/api/${url}`;

	return URL;
};

export const wrapFetchSSO = async (url, options = { headers: {} }, params = {}) => {
	const URL = apiUrl(url, params);

	const headers = new Headers({
		'Content-Type': 'application/json',
		Accept: 'application/json',
		...options.headers,
	});

	appendXsrfToken(headers, options.method);

	const result = await fetch(URL, { ...options, headers, credentials: 'include' });

	return result.json();
};

export const wrapFetchFormDataSSO = async (url, options, params = {}) => {
	const URL = apiUrl(url, params);

	const headers = new Headers(options.headers || {});
	appendXsrfToken(headers, options.method);

	const result = await fetch(URL, { ...options, headers, credentials: 'include' });

	return result.json();
};

export const wrapSSOFetch = async (url, options = { headers: {} }, params = {}) => {
	return wrapFetchSSO(url, options, params);
};

export const wrapSSOFetchFormData = async (url, options, params = {}) => {
	return wrapFetchFormDataSSO(url, options, params);
};
